import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TooltipDirective, TooltipType } from '@cumlaude/shared-components-overlays';
import { DecimalPipe } from '@angular/common';

export type MetricsData = {
	percentage: number | null;
	tooltip?: TooltipType;
	clickHandler?: () => void;
};

@Component({
	selector: 'app-metrics-series',
	templateUrl: './metrics-series.component.html',
	styleUrls: ['./metrics-series.component.scss'],
	imports: [TooltipDirective, DecimalPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetricsSeriesComponent {
	metrics = input.required<MetricsData[]>();
	paddingLeft = input<number>(0);
	barWidth = input.required<number>();
	private readonly minBarWidth = 12;
	private readonly safeBarWidth = computed(() => Math.max(this.barWidth(), this.minBarWidth));
	rectPadding = computed(() => 6 / this.safeBarWidth());
	rectWidth = computed(() => (this.safeBarWidth() - this.minBarWidth) / this.safeBarWidth());

	getWidth() {
		return this.metrics().length * this.safeBarWidth() + this.paddingLeft() + 0.5;
	}
}
